export default __webpack_public_path__ + "static/media/bg-small-blue-light.b6473981.svg";